/* eslint-disable jsx-a11y/role-supports-aria-props */
import { useEffect } from 'react';
import cs from 'classnames';
import { ChoiceType } from 'types/models';

interface SingleChoiceProps {
  children: React.ReactNode;
  choiceGroupId: number;
  choiceGroupIndex: number;
  choiceIndex: number;
  choiceType: ChoiceType;
  disabled: boolean;
  hasNestedChoice: boolean;
  isSelected: boolean;
  numberOfChoices: number;
  outOfStock: boolean;
  updateChoice: (
    choiceIndex: number,
    choiceGroupIndex: number,
    quantity?: number,
    hasNestedChoice?: boolean,
  ) => void;
}

export const SingleChoice: React.FC<SingleChoiceProps> = ({
  children,
  choiceGroupId,
  choiceGroupIndex,
  choiceIndex,
  choiceType,
  disabled,
  hasNestedChoice,
  isSelected,
  numberOfChoices,
  outOfStock,
  updateChoice,
}) => {
  const onChoiceSelectorClick = (
    choiceIndex: number,
    choiceGroupIndex: number,
  ) => {
    updateChoice(choiceIndex, choiceGroupIndex, undefined, hasNestedChoice);
  };

  const inputType =
    choiceType === ChoiceType.SingleRequired ? 'radio' : 'checkbox';

  const selectorClasses = cs(
    isSelected && 'checked',
    outOfStock && 'out-of-stock',
    disabled && 'disabled',
    `choice-selector ${inputType}`,
  );

  useEffect(() => {
    // Preselect if only 1 choice present and is a required choice
    if (
      choiceType === ChoiceType.SingleRequired &&
      numberOfChoices === 1 &&
      !isSelected &&
      !disabled &&
      !outOfStock
    ) {
      updateChoice(choiceIndex, choiceGroupIndex, undefined, hasNestedChoice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <label
      className={selectorClasses}
      htmlFor={`choice-${choiceGroupId}-${choiceIndex}-${choiceGroupIndex}`}
    >
      <input
        type={inputType}
        id={`choice-${choiceGroupId}-${choiceIndex}-${choiceGroupIndex}`}
        name={`choiceGroup:${choiceGroupId}`}
        checked={isSelected}
        disabled={disabled || outOfStock}
        onChange={() => onChoiceSelectorClick(choiceIndex, choiceGroupIndex)}
        aria-checked={isSelected}
        aria-disabled={disabled || outOfStock}
      />
      {children}
    </label>
  );
};
